import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  &.noFlex {
    flex: none;
  }
`;

export const Message = styled.div`
  font-size: 20px;
  color: #aac;
  text-align: center;

  span {
    font-size: 14px;
    color: #667;
  }
`;
